function ErrorPage() {
    return (
            <text>❗️404 ERROR❗️</text>
    )
}

export default ErrorPage;